module.exports = "/_next/static/images/Logo--white-44c347872eadc40dffa97966c3cd25b9.svg";